module.exports = __webpack_public_path__ + "fonts/loleicons.41063df.ttf";